<div class="login">
  <div class="template login-page-logo-template">
    <div class="content">
      <svg class="logo">
        <use [attr.href]="imageAssets.logo" />
      </svg>
    </div>
  </div>

  <div class="template login-template">
    <div class="content">
      <mat-card class="login-card">
        <mat-card-title>
          <span>
            @if (!isAuthenticated()) {
              <button color="primary" data-testid="login-button" mat-raised-button (click)="login()">Logg inn</button>
              <p>Du er logget ut.</p>
            }
          </span>
        </mat-card-title>

        @if (!!authErrorMessage) {
          <app-ice-alert type="error">
            <div heading>Innlogging mislyktes</div>
            <div>{{ authErrorMessage }}</div>
          </app-ice-alert>
          @if (isAuthenticated()) {
            <span>
              <button color="primary" data-testid="logout-button" mat-raised-button (click)="logout()">Logg ut</button>
            </span>
          }
        }
      </mat-card>
    </div>
  </div>
</div>
